export default __webpack_public_path__ + "static/media/CrossIcon.2af86f3d.svg";